package ru.villawonka.app.presentation.screens.postCard.viewmodel

import ru.villawonka.app.common.mvvm.SingleLiveEvent
import ru.villawonka.app.domain.model.PostDomain
import ru.villawonka.app.presentation.model.ConversationDetailsUIModel

sealed class PostCardUIEvent : SingleLiveEvent {
    
    data class OpenPhotoSliderScreen(
        val initialPage: Int,
        val photos: List<String>
    ) : PostCardUIEvent()

    data class OpenExternalLink(
        val link: String,
    ) : PostCardUIEvent()

    data class OpenConversationDetailsScreen(
        val conversationDetails: ConversationDetailsUIModel
    ) : PostCardUIEvent()

    data class OpenSendReportScreen(
        val post: PostDomain
    ) : PostCardUIEvent()
}